import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderCode } from '@posilka/client/api/orders';
import { Section } from '@/components/Section';

/** Yuboruvchi kodni qayta ko'rishi (bosilgandagina so'raladi). */
export function DeliveryCode({ orderId }: { orderId: string }) {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);
  const code = useOrderCode(orderId, shown);
  return (
    <Section title={t('order.codeTitle')}>
      <div className="flex items-center justify-between gap-3 px-5 pt-4 pb-3">
        <span className="flex gap-1.5">
          {(shown ? (code.data?.code ?? '····') : '••••').split('').map((d, i) => (
            <span
              key={i}
              className="grid h-12 w-10 place-items-center rounded-xl border border-line bg-surface-2 font-display text-xl font-bold"
            >
              {d}
            </span>
          ))}
        </span>
        <button
          type="button"
          className="btn-secondary px-3.5 py-2 text-sm"
          onClick={() => setShown((s) => !s)}
        >
          {shown ? t('order.hideCode') : t('order.showCode')}
        </button>
      </div>
      <p className="px-5 pb-4 text-xs text-muted">{t('order.codeHint')}</p>
    </Section>
  );
}
